/* global window:false */

export default window.Backbone;
